export default "__VITE_ASSET__B02h0kO0__";